import Bullets from '@atoms/Bullets/Bullets';
import { ILightBoxImage } from '@models/ILightBoxImage';
import { IMeta } from '@models/IMeta';
import ImageLightBox from '@molecules/ImageLightBox/ImageLightBox';

interface Props {
  readonly author: string;
  readonly genre: string[];
  readonly media: ILightBoxImage;
  readonly meta: IMeta | null;
  readonly publishedDate: string;
  readonly readTime: string;
  readonly title: string;
}

const ArticleHero = ({
  author,
  genre = [],
  media,
  meta,
  publishedDate,
  readTime,
  title,
}: Props) => {
  const bulletsArray = [author, genre[0], publishedDate, readTime];

  return (
    <section
      className="component-padding bg-white text-black-100 dark:bg-black-100 dark:text-white"
      data-testid="CT-04D-Article-Hero"
    >
      <div className="component-padding w-full" />
      <div className="container">
        <div className="grid xl:grid-cols-12">
          <div className="col-span-10 xl:col-start-2 xl:col-end-8">
            {title && (
              <h1
                className="pb-8 xl:pb-13"
                data-testid="CT-04D-Article-Hero-Title"
                data-epi-property-name={meta?.editHints?.title}
              >
                {title}
              </h1>
            )}
            {bulletsArray && bulletsArray.length > 0 && (
              <Bullets
                dataTestId="CT-04D-Article-Hero-Bullets"
                bullets={bulletsArray}
              />
            )}
          </div>
        </div>

        {media?.image && (
          <div className="pt-13 xl:pt-20">
            <ImageLightBox
              dataTestId="CT-04D-Article-Hero-Image"
              imageClasses="col-span-12 col-start-1 w-full h-full object-cover"
              contentIds={
                media?.meta?.contentLink
                  ? [media.meta.contentLink as string]
                  : []
              }
              {...media}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default ArticleHero;
